// Existing Inputs notifications invalidate read models only. They never acquire data.
interface InputsSocket {
  connected?: boolean;
  on(event: string, listener: (...args: any[]) => void): unknown;
  off(event: string, listener: (...args: any[]) => void): unknown;
}

export function subscribeMackInputsChanges(socket: InputsSocket, reload: () => void): () => void {
  const seen = new Set<string>();
  let reconnectRead = socket.connected === false;
  const changed = (detail: unknown) => {
    const payload = detail && typeof detail === 'object' ? detail as Record<string, unknown> : null;
    if ((payload?.agent && payload.agent !== 'MACK') || (payload?.domain && payload.domain !== 'TRADING') ||
        (payload?.panel && payload.panel !== 'Inputs') || (payload?.read_route && payload.read_route !== '/api/mack/inputs')) return;
    const identities = [payload?.change_id, payload?.revision_id]
      .filter((value): value is string => typeof value === 'string' && value.length > 0);
    if (identities.some(identity => seen.has(identity))) return;
    identities.forEach(identity => seen.add(identity));
    while (seen.size > 256) seen.delete(seen.values().next().value as string);
    reload();
  };
  const local = (event: Event) => changed((event as CustomEvent).detail);
  const disconnected = () => { reconnectRead = true; };
  const connected = () => { if (reconnectRead) { reconnectRead = false; reload(); } };
  socket.on('mack_inputs_changed', changed);
  socket.on('disconnect', disconnected);
  socket.on('connect', connected);
  window.addEventListener('mack-inputs-updated', local);
  return () => {
    socket.off('mack_inputs_changed', changed);
    socket.off('disconnect', disconnected);
    socket.off('connect', connected);
    window.removeEventListener('mack-inputs-updated', local);
  };
}
